import ruku from '@/assets/ruku.png'
const menuList = [
    {
        path: 'registerReceipt',
        title: '应收管理',
        resoureUrl: '',
        menuIcon: 'menu-icon2',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/RMS/invoicedAndShipped',
                title: '应收订单',
                menuName: '应收订单',
                resoureUrl: 'RMS/invoicedAndShipped',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/RMS/aging-report',
                title: '账龄报表',
                menuName: '账龄报表',
                resoureUrl: 'RMS/agingReport',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/registerReceipt',
                title: '回款登记',
                menuName: '回款登记',
                resoureUrl: 'sellAccount/registerReceipt',
                menuIcon: ''
            },
            {
                path: '/paymentConfirmation',
                title: '回款确认-废弃',
                menuName: '回款确认-废弃',
                resoureUrl: 'settlement/paymentConfirmation',
                menuIcon: 'menu-icon5'
            },
            {
                path: '/bankMatch',
                title: '回款匹配',
                menuName: '回款匹配',
                resoureUrl: 'settlement/bankMatch',
                menuIcon: ''
            },
            {
                path: '/yingdaMatch',
                title: '回款导入匹配',
                menuName: '回款导入匹配',
                resoureUrl: 'settlement/yingdaMatch',
                menuIcon: 'menu-icon8'
            },
            {
                path: '/receiptAudit',
                title: '回款审批',
                menuName: '回款审批',
                resoureUrl: 'sellAccount/receiptAudit',
                menuIcon: 'menu-icon2'
            },
            {
                path: '/refoundAccount',
                title: '回款台账',
                menuName: '回款台账',
                resoureUrl: 'settlement/refoundAccount',
                menuIcon: 'menu-icon3'
            },
            {
                path: '/invoiceDetail',
                title: '金税发票台账',
                menuName: '金税发票台账',
                resoureUrl: 'settlement/invoiceDetail',
                menuIcon: 'menu-icon6'
            },
            {
                path: '/cancelAuditRecords',
                title: '回款撤销台账',
                menuName: '回款撤销台账',
                resoureUrl: 'settlement/cancelAuditRecords',
                menuIcon: 'menu-icon8'
            },
            {
                path: '/receiptUnnamed',
                title: '不知名回款',
                menuName: '不知名回款',
                resoureUrl: 'sellAccount/receiptUnnamed',
                menuIcon: 'menu-icon8'
            },
            {
                path: '/distributionRepayment',
                title: '分销回款',
                menuName: '分销回款',
                resoureUrl: 'sellAccount/distributionRepayment',
                menuIcon: 'menu-icon8'
            },
            {
                path: '/internationalRepayment',
                title: '国际回款',
                menuName: '国际回款',
                resoureUrl: 'sellAccount/internationalRepayment',
                menuIcon: 'menu-icon8'
            },
            {
                path: '/customerRefund',
                title: '客户退款',
                menuName: '客户退款',
                resoureUrl: 'sellAccount/customerRefund',
                menuIcon: 'menu-icon8'
            },
            {
                path: '/returnReportInfo',
                title: '财务日报',
                menuName: '财务日报',
                resoureUrl: 'settlement/returnReportInfo',
                menuIcon: 'menu-icon8'
            },
            {
                path: '/returnedMoneyNote',
                title: '票据管理',
                menuName: '票据管理',
                resoureUrl: 'settlement/returnedMoneyNote',
                menuIcon: 'menu-icon8'
            }
        ]
    },
    {
        path: 'settlementBy',
        title: '进项管理',
        resoureUrl: "",
        menuIcon: 'menu-icon3',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/purchaseOrder',
                title: '采购订单台账',
                menuName: '采购订单台账',
                resoureUrl: 'paymentRequest/index',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/purchaseOrderSpecial',
                title: '四角订单台账',
                menuName: '四角订单台账',
                resoureUrl: 'paymentSpecialRequest/index',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/chargeBackList',
                title: '退换单记录',
                menuName: '退换单记录',
                resoureUrl: 'basicDataMaintenance/chargeBackList',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/settlementBy',
                title: '结算发起',
                menuName: '结算发起',
                resoureUrl: 'invoiceManagement/settlementBy',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/invoiceConfirm',
                title: '商务发票审核',
                menuName: '商务发票审核',
                resoureUrl: 'invoiceManagement/invoiceConfirm',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/invoiceApply',
                title: '财务发票审核',
                menuName: '财务发票审核',
                resoureUrl: 'invoiceManagement/invoiceApply',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/invoiceAccount',
                title: '进项发票台账',
                menuName: '进项发票台账',
                resoureUrl: 'invoiceManagement/invoiceAccount',
                menuIcon: 'rp_icon15'
            },
            // {
            //     path: '/redInvoiceAccount',
            //     title: '红字发票',
            //     menuName: '红字发票',
            //     resoureUrl: 'invoiceManagement/redInvoiceAccount',
            //     menuIcon: 'rp_icon15'
            // },
            {
                path: '/redInvoiceManagement',
                title: '红冲管理台账',
                menuName: '红冲管理台账',
                resoureUrl: 'invoiceManagement/redInvoiceManagement',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/purchaseAccount',
                title: '采购单台账',
                menuName: '采购单台账',
                resoureUrl: 'invoiceManagement/purchaseAccount',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/receiptReview',
                title: '签收单审核',
                menuName: '签收单审核',
                resoureUrl: 'invoiceManagement/receiptReview',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/featureIncome',
                title: '未来进项台账',
                menuName: '未来进项台账',
                resoureUrl: 'featureIncome/index',
                menuIcon: 'rp_icon15'
            }
        ]
    },
    {
        path: 'paymentConfirmationPlatForm',
        title: '供应商业务',
        resoureUrl: "",
        menuIcon: 'menu-icon4',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/serviceReceiptConfirm',
                title: '进项发票初审',
                menuName: '进项发票初审',
                resoureUrl: 'platformWork/serviceReceiptConfirm',
                menuIcon: 'rp_icon15 '
            },
            {
                path: '/platformOrderConfirm',
                title: '进项发票终审',
                menuName: '进项发票终审',
                resoureUrl: 'platformWork/orderConfirm',
                menuIcon: 'rp_icon15'
            },
			{
			    path: '/platformInvoiceRegister',
			    title: '登记销项发票',
			    menuName: '登记销项发票',
			    resoureUrl: 'platformWork/invoiceRegister',
			    menuIcon: 'rp_icon15'
			},
            {
                path: '/platformInvoiceAccount',
                title: '进项发票台账',
                menuName: '进项发票台账',
                resoureUrl: 'platformWork/invoiceAccount',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/salesInvoiceAccount',
                title: '销项发票台账',
                menuName: '销项发票台账',
                resoureUrl: 'platformWork/salesInvoiceAccount',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/platformContract',
                title: '供应商合同',
                menuName: '供应商合同',
                resoureUrl: 'platformWork/platformContract',
                menuIcon: 'rp_icon15'
            }
            ,
            {
                path: '/platformSettlementDetails',
                title: '结算明细',
                menuName: '结算明细',
                resoureUrl: 'platformWork/platformSettlementDetails',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/platformOrder',
                title: '销售订单',
                menuName: '销售订单',
                resoureUrl: 'platformWork/platformOrder',
                menuIcon: 'rp_icon15'
            }
        ]
    },
    {
        path: 'paymentRequest',
        title: '请款管理',
        resoureUrl: "",
        menuIcon: 'menu-icon5',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/approval',
                title: '商务请款审批',
                menuName: '商务请款审批',
                resoureUrl: 'paymentRequest/approval',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/account',
                title: '商务请款台账',
                menuName: '商务请款台账',
                resoureUrl: 'paymentRequest/account',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/financeApproval',
                title: '财务请款审批',
                menuName: '财务请款审批',
                resoureUrl: 'paymentRequest/financeApproval',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/financeSapList',
                title: 'SAP支付',
                menuName: 'SAP支付',
                resoureUrl: 'paymentRequest/financeSapList',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/platformRequestAccount',
                title: '支付明细',
                menuName: '支付明细',
                resoureUrl: 'paymentRequest/platformRequestAccount',
                menuIcon: 'rp_icon7'
            },
            {
                path: '/servicerRefundRegist',
                title: 'SP供应商退款',
                menuName: 'SP供应商退款',
                resoureUrl: 'paymentRequest/servicerRefundRegist',
                menuIcon: 'rp_icon7'
            },
            {
                path: '/advanceVerifyList',
                title: '预付款核销台账',
                menuName: '预付款核销台账',
                resoureUrl: 'paymentRequest/advanceVerifyList',
                menuIcon: 'rp_icon13'
            },
            {
                path: '/advanceVerifyAudit',
                title: '核销单据审核',
                menuName: '核销单据审核',
                resoureUrl: 'paymentRequest/advanceVerifyAudit',
                menuIcon: 'rp_icon14'
            },
            {
                path: '/servicerFineAccount',
                title: 'SP供应商罚款台账',
                menuName: 'SP供应商罚款台账',
                resoureUrl: 'paymentRequest/servicerFineAccount',
                menuIcon: 'rp_icon12'
            },

            {
                path: '/tenPaymentRecord',
                title: 'SP供应商缴费审核',
                menuName: 'SP供应商缴费审核',
                resoureUrl: 'basicDataMaintenance/tenPaymentRecord',
                menuIcon: 'rp_icon15'
            },

        ]
    },
    {
        path: 'platformMessage',
        title: '基础数据维护',
        resoureUrl: "",
        menuIcon: 'menu-icon6',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/servicerMessage',
                title: '供应商信息',
                menuName: '供应商信息',
                resoureUrl: 'basicDataMaintenance/servicerMessage',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/platformQuotaManagement',
                title: '供应商额度',
                menuName: '供应商额度',
                resoureUrl: 'platformWork/platformQuotaManagement',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/platformQuery',
                title: '供应商查询',
                menuName: '供应商查询',
                resoureUrl: 'platformWork/platformQuery',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/servicerTenType',
                title: 'S单SP供应商',
                menuName: 'S单SP供应商',
                resoureUrl: 'basicDataMaintenance/servicerTenType',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/operationsWorkbench',
                title: '运维工作台',
                menuName: '运维工作台',
                resoureUrl: 'basicDataMaintenance/operationsWorkbench',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/returnedPaymentConfig',
                title: '齐心收款方式',
                menuName: '齐心收款方式',
                resoureUrl: 'basicDataMaintenance/returnedPaymentConfig',
                menuIcon: 'rp_icon15'
            }
        ]
    },
	{
	    path: 'externalBusiness',
	    title: '外部业务',
	    resoureUrl: "",
	    menuIcon: 'menu-icon7',
	    requireAuth: true,
	    rotate: false,
	    children: [
	        {
	            path: '/hxbankFactoring',
	            title: '华夏银行保理',
	            menuName: '华夏银行保理',
	            resoureUrl: 'externalBusiness/hxbankFactoring',
	            menuIcon: 'rm_icon1'
	        },
	    ]
    },
    {
        path: 'supplierSettlement',
        title: 'SRM供应商结算',
        resoureUrl: "",
        menuIcon: 'menu-icon8',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/srmPurchaseOrder',
                title: '采购订单',
                menuName: '采购订单',
                resoureUrl: 'supplierSettlement/srmPurchaseOrder',
                menuIcon: 'rm_icon1',
            },
            {
                path: '/srmBillAuditInfo',
                title: '对账单审核',
                menuName: '对账单审核',
                resoureUrl: 'supplierSettlement/srmBillAuditInfo',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/srmBillBook',
                title: '对账单台账',
                menuName: '对账单台账',
                resoureUrl: 'supplierSettlement/srmBillBook',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/paymentAudit',
                title: '请款审核',
                menuName: '请款审核',
                resoureUrl: 'supplierSettlement/paymentAudit',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/paymentBook',
                title: '请款台账',
                menuName: '请款台账',
                resoureUrl: 'supplierSettlement/paymentBook',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/srmPostingItemBook',
                title: '过账物料台账',
                menuName: '过账物料台账',
                resoureUrl: 'supplierSettlement/srmPostingItemBook',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/prepaidVerificationBook',
                title: '预付核销台账',
                menuName: '预付核销台账',
                resoureUrl: 'supplierSettlement/prepaidVerificationBook',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/srmRedInvoiceAccount',
                title: '红字发票',
                menuName: '红字发票',
                resoureUrl: 'supplierSettlement/srmRedInvoiceAccount',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/srmRefund',
                title: 'SRM供应商退款',
                menuName: 'SRM供应商退款',
                resoureUrl: 'supplierSettlement/srmRefund',
                menuIcon: 'rp_icon15'
            }
        ]
    },
    {
        path: 'platformSettlement',
        title: '商品平台结算',
        resoureUrl: "",
        menuIcon: 'menu-icon9',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/tabs',
                title: '平台结算',
                menuName: '平台结算',
                resoureUrl: 'platformSettlement/tabs',
                menuIcon: 'rp_icon15'
            },
            {
                path: '/platformFeeAccrual',
                title: '平台费预提',
                menuName: '平台费预提',
                resoureUrl: 'platformSettlement/platformFeeAccrual',
                menuIcon: 'rp_icon15'
            }
        ]
    },
    {
        path: 'systemManage',
        title: '系统管理',
        resoureUrl: "",
        menuIcon: 'menu-icon10',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/reqApiLog',
                title: '外部接口调用',
                menuName: '外部接口调用',
                resoureUrl: 'systemManage/reqApiLog',
                menuIcon: 'rp_icon15'
            }
        ]
    },
    {
        path: 'b2bFinancialReport',
        title: 'B2B财务报表',
        resoureUrl: '',
        menuIcon: 'el-icon-coin',
        requireAuth: true,
        rotate: false,
        children: [
            {
                path: '/supplierInvoiceReport',
                title: '供应商来票报表',
                menuName: '供应商来票报表',
                resoureUrl: 'paymentRequest/supplierInvoiceReport',
                menuIcon: 'rm_icon1'
            },
            {
                path: '/supplierBalanceReport',
                title: '供应商余额报表',
                menuName: '供应商余额报表',
                resoureUrl: 'paymentRequest/supplierBalanceReport',
                menuIcon: 'rm_icon1'
            }
        ]
    }
]

export default menuList
